import { gql, useMutation } from '@apollo/client';
import { PROJECT_PAGE_FRAGMENT } from '../gql/projectPageFragment';
import { get } from 'lodash';
import { useCallback } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import toast from 'helpers/toast';

const UPDATE_PROJECT_PAGE = gql`
  mutation UpdateProjectPage($input: UpdateProjectPageInput!) {
    updateProjectPage(input: $input) {
      errors {
        error
        message
      }
      page {
        __typename
        ...ProjectPageFragment
      }
    }
  }
  ${PROJECT_PAGE_FRAGMENT}
`;

const messages = defineMessages({
  updatePageError: {
    id: 'ProjectPage.hooks.updatePageError',
    defaultMessage: 'This was an error updating the project note page',
    description: 'Graphql error message for creating a project note page',
  },
});

const useUpdatePageContent = () => {
  const { formatMessage } = useIntl();

  const [updatePageContentMutation, { loading }] = useMutation(
    UPDATE_PROJECT_PAGE,
    {
      onCompleted: (res) => {
        const errors = get(res, 'updateProjectPage.errors', null);
        if (errors.length) {
          toast.error(formatMessage(messages.updatePageError));
        }
      },
      onError: () => {
        toast.error(formatMessage(messages.updatePageError));
      },
    },
  );

  const updatePageContent = useCallback(
    ({ pageId, content }) =>
      updatePageContentMutation({
        variables: {
          input: {
            pageId,
            tiptapContent: JSON.stringify(content),
          },
        },
      }),
    [updatePageContentMutation],
  );

  return {
    updatePageContent,
    loading,
  };
};

export default useUpdatePageContent;
